module.exports = __webpack_public_path__ + "static/coupon2-81ec258c3203ae2a8545c7f4bf2f8c66.png";